import axios from "axios";
import { gandalfAuth } from "./gandalfAuth";
import store from "../store/store";
import { setImpersonationExpired } from "../store/authSlice";

// Module-level flag — set to true once impersonation expires to block all further requests
let impersonationSessionExpired = false;

export const resetImpersonationExpiredFlag = () => {
    impersonationSessionExpired = false;
};

// Request interceptor — blocks all calls once impersonation token has expired
axios.interceptors.request.use(
    (config) => {
        if (impersonationSessionExpired) {
            return Promise.reject(new Error("Impersonation session expired"));
        }

        // Skip adding Gandalf token in production
        if (process.env.REACT_APP_ENV !== "production") {
            // Only add Gandalf token to backend API requests
            const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
            const isBackendRequest = config.url?.includes(backendUrl) ||
                                    config.url?.startsWith("/") ||
                                    !config.url?.includes("://");

            if (isBackendRequest) {
                const token = gandalfAuth.getToken();
                if (token) {
                    config.headers["X-Gandalf-Token"] = token;
                    if (!config.headers.Authorization) {
                        config.headers.Authorization = `Bearer ${token}`;
                    }
                }
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle 401 Unauthorized errors
        if (error.response?.status === 401) {
            // Don't clear token or redirect for these signup-related endpoints
            const isGandalfEndpoint = error.config?.url?.includes('/gandalf-answer');
            const isValidateEndpoint = error.config?.url?.includes('/validate-gandalf-token');
            const isInitializeUserEndpoint = error.config?.url?.includes('/initialize-new-user');

            if (!isGandalfEndpoint && !isValidateEndpoint && !isInitializeUserEndpoint) {
                // If currently impersonating, block all future calls and show expired dialog
                const isImpersonating = sessionStorage.getItem("isImpersonating") === "true";
                if (isImpersonating) {
                    impersonationSessionExpired = true;
                    store.dispatch(setImpersonationExpired(true));
                    return Promise.reject(error);
                }

                // Clear token and redirect to Gandalf screen
                gandalfAuth.clearToken();

                // Skip redirect in production
                if (process.env.REACT_APP_ENV !== "production") {
                    window.location.href = "/";
                }
            }
        }
        return Promise.reject(error);
    }
);
